import { InstrumentDO } from 'score_data';
import { ScoreViewer, ScoreViewerEvent, ScoreViewerEventType }
	from 'score_performance';
import { VisualNoteGroup } from 'score_render';
import { FingeringVisualizerFactory, IFingeringVisualizerFactory }
	from './FingeringVisualizerFactory';
import { IFingeringVisualizer } from './IFingeringVisualizer';

export class FingeringDisplayManager {
	/**To create custom fingering visualizers, first create a custom
	 * [IFingeringVisualizerFactory] that creates your [IFingeringVisualizer]s
	 * and assign it to the static visualizerFactory field before initializing
	 * the [AbstractPlayer]. */
    	
	private _scoreViewer:ScoreViewer;
	private _visualizer:IFingeringVisualizer;
	
	/**the [IFingeringVisualizerFactory] instance that creates the unique
	 * [IFingeringVisualizer] for each instrument*/
	public static visualizerFactory:IFingeringVisualizerFactory = 
		new FingeringVisualizerFactory();
	
	constructor(){
		
	}

	/**sets the fingering display (or removes it) for the new instrument
	 * returns true if a change in the display occurred.*/
	public setInstrument(inst:InstrumentDO,
			showFingeringsIfAvailable:boolean):void {
		if (this._visualizer != null){
			this._visualizer.destroy();
			this._visualizer = null;
		}
		if (showFingeringsIfAvailable){
			this._visualizer =
				FingeringDisplayManager.visualizerFactory.create(inst);
		}
	}
	
	public setNewScore(scoreViewer:ScoreViewer):void {
		this._removeListeners();
		this._scoreViewer = scoreViewer;
		this._addListeners();
	}
	
	private _onScoreViewerEvent = (e:ScoreViewerEvent):void => {
		switch (e.type){
			case ScoreViewerEventType.noteGroupClicked: {
				this._displayFingering((e.visualNoteGroup));
				break;
			}
			
			case ScoreViewerEventType.noteReached: {
				if (e.visualNoteGroup.noteGroup.visible){
					this._displayFingering(e.visualNoteGroup);
				}
				break;
			}
		}
	}
	
	private _displayFingering(vng:VisualNoteGroup):void {
		if (this._visualizer == null) return;
		
		if (vng.noteGroup.isRest){
			return; //no fingerings for rests
		}
		
		this._visualizer.showFingering(
			vng.noteGroup.visibleNotes[0].displayCents);
	}
	
	private _addListeners():void {
		this._scoreViewer.event.on(this._onScoreViewerEvent);
	}
	
	private _removeListeners():void {
		if (this._scoreViewer != null){
			this._scoreViewer.event.off(this._onScoreViewerEvent);
		}
	}
	
	public get showingFingerings():boolean {
		return this._visualizer != null;
	}
}